/** Make sure the error code is added to `errors.json` files
 * when using this or changing the value of the field */
export const WORKSPACE_NAME_STEP_WORKSPACE_NOT_FOUND_ERROR = {
    code: 'workspaceName.notFound',
    path: ['workspaceName'],
    message: '',
    isServerError: true,
};
